import React from 'react';
import { IconCard } from '../IconCard';
import styles from './Problems.css';

const PROBLEMS = [
    {
        iconName: 'cloud',
        title: 'Still only in your memory',
        description: 'First loves, difficult choices, quiet victories, and moments that changed you may exist only in your mind. Without a place to keep them, entire chapters can disappear.'
    },
    {
        iconName: 'hourglass',
        title: 'The “someday” trap',
        description: 'You want to record your story, but a whole life feels too big to begin. So you keep telling yourself you will do it later.'
    },
    {
        iconName: 'puzzle',
        title: 'Scattered fragments',
        description: 'Photos, notes, and recordings preserve separate moments. They do not yet tell the complete story of who you are.'
    }
];

function Problems() {
    return (
        <section className={styles.problemsSection}>
            <h2 className={styles.problemsTitle}>The best stories are the ones no one wrote down</h2>
            <ul className={styles.problemsList}>
                {PROBLEMS.map(problem => (
                    <IconCard
                        key={problem.title}
                        iconName={problem.iconName}
                        title={problem.title}
                        description={problem.description}
                        isIconOnLeft
                    />
                ))}
            </ul>
        </section>
    );
}

export {
    Problems
};
